@if (client.isL || client.isX) {
<nav class="pos-relative z-1"
     role="navigation"
     (offClick)="close()"
     [offClickOff]="!client.isTouchy || isCms"
     [offClickFilter]="'.meganav__content'">
    <ul class="inline-block pe-auto">
        @for (item of items; track $index) {
        @if (!item.hide && ifCustomerGroup(item.visibility)) {
        <li class="inline-block meganav-item"
            csOverrideId
            [elementId]="item.text"
            [toggleClass]="'is-active'"
            [toggleClassBy]="[toggleGroupId, $index]">
            <href [link]="item.link">
                <span class="p1"
                      [class._is-cms]="isCms"
                      [ngClass]="item.color"
                      cy-navCategory
                      (mouseenter)="handleMouseEnter($index, item)"
                      (mouseleave)="handleMouseLeave($index)"
                      (click)="handleClick($index)"
                      [gtmTrackClick]="{category: 'MegaNav', action: 'MegaNav Links', label: 'MegaNav Links ' + item.link}"
                      *iCms="'text' of item">
                </span>
            </href>
        </li>
        }
        }
    </ul>
</nav>
}